import { render, staticRenderFns } from "./PowerButton.vue?vue&type=template&id=022aea4e&scoped=true&"
import script from "./PowerButton.vue?vue&type=script&lang=ts&"
export * from "./PowerButton.vue?vue&type=script&lang=ts&"
import style0 from "./PowerButton.vue?vue&type=style&index=0&id=022aea4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022aea4e",
  null
  
)

export default component.exports